import { planTypes, trackingPlanTypes } from '@/common/constants';
import { isFromZeConsumption } from './helper/utils';
import { get } from 'lodash';

export default {
  key: planTypes[planTypes.EVENT_SAAS],
  data() {
    return {
      logo: require('@/assets/plans/eventsaas.svg'),
      title: `${this.$t('billing.planform.title.zoom_events')}${isFromZeConsumption() ? ' ' + this.$t('billing.events.ppa.title') : ''}`,
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.EVENT_SAAS,
      description: this.$t('billing.events.eventSaas.addon_desc'),
      totalLimitDesc: "",
      configDescription: this.$t('billing.events.eventSaas.desc'),
    };
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  }
};
